export default __webpack_public_path__ + "static/media/brain.03eb81af.webp";